var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/modules/_core.js
// module id = 94
// module chunks = 168707334958949